import { render, staticRenderFns } from "./departure-situation.vue?vue&type=template&id=f5787a04&"
import script from "./departure-situation.vue?vue&type=script&lang=js&"
export * from "./departure-situation.vue?vue&type=script&lang=js&"
import style0 from "./departure-situation.vue?vue&type=style&index=0&id=f5787a04&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5787a04')) {
      api.createRecord('f5787a04', component.options)
    } else {
      api.reload('f5787a04', component.options)
    }
    module.hot.accept("./departure-situation.vue?vue&type=template&id=f5787a04&", function () {
      api.rerender('f5787a04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/stevedoring/departure-situation.vue"
export default component.exports